import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environments';
import { PaymentPlan } from '../models/enums/payment-plan';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaymentPlanService {

  constructor(private httpClient: HttpClient) { }

  createStripeUrl(plan: PaymentPlan): Observable<{url: string}>{
    return this.httpClient.get<{url: string}>(`${environment.paymentUrl}/redirect/${plan}`);
  }

  createDiscountStripeUrl(code:string): Observable<{url: string}>{
    return this.httpClient.get<{url: string}>(`${environment.paymentUrl}/redirect/discounted/${code}`);
  }

  createCustomPlanStripeUrl(monthlyPriceId:string): Observable<{url: string}>{
    return this.httpClient.get<{url: string}>(`${environment.paymentUrl}/redirect/custom/${monthlyPriceId}`);
  }

  cancelPlan(): Observable<{url: string}>{
    return this.httpClient.get<{url: string}>(`${environment.paymentUrl}/cancel`);
  }

  updatePlan(plan: PaymentPlan): Observable<{url: string}>{
    return this.httpClient.get<{url: string}>(`${environment.paymentUrl}/update/${plan}`);
  }

  createStripeUrlForRebilling(rebillingInfoId: number): Observable<{url: string}>{
    return this.httpClient.get<{url: string}>(`${environment.paymentUrl}/redirect/rebilling/${rebillingInfoId}`);
  }
}
